import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime-corejs2/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime-corejs2/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime-corejs2/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime-corejs2/helpers/esm/inherits";
import _taggedTemplateLiteral from "@babel/runtime-corejs2/helpers/esm/taggedTemplateLiteral";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    &:hover ", ".closed {\n      background-color: ", ";\n    }\n  "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import * as React from 'react';
import * as PropTypes from 'prop-types';
import styled from 'styled-components';
import { AddIcon, RemoveIcon } from '@origin-digital/icon';
import { Box } from '@origin-digital/layout';
import { media } from '../../helpers/mediaStyle.helper';
import { Heading4 } from '../Heading';
import { Text } from '../Text';
import { Colors } from '../../consts/palette.const';
import { FontSizes, FontWeights, Spacing } from '../../consts/metrics.const';
import { unitPx } from '../../helpers/metrics.helper';
import { slideIn } from '../animation';
import { enhanceWithTrackable } from '../hocs';
var DISPLAY_NAME = 'accordion';
var Header = styled(Box).withConfig({
  displayName: "Accordion__Header",
  componentId: "sc-1xkc3dm-0"
})(["padding:", " 0;display:flex;align-items:flex-start;cursor:pointer;h4{flex-grow:1;padding-right:", ";", "}"], function (_ref) {
  var condensed = _ref.condensed;
  return unitPx(condensed ? Spacing.P_Y_SM : Spacing.P_Y_LG);
}, unitPx(Spacing.P_X_LG), function (_ref2) {
  var smallLabel = _ref2.smallLabel;
  return smallLabel && "font-size: ".concat(unitPx(FontSizes.BODY), ";");
});
Header.displayName = DISPLAY_NAME;
var Body = styled(Box).withConfig({
  displayName: "Accordion__Body",
  componentId: "sc-1xkc3dm-1"
})(["margin:0;height:0;font-size:", ";font-weight:", ";color:", ";overflow:hidden;&.open{margin-bottom:", ";height:100%;overflow:visible;animation:", " 0.3s ease-in-out;}"], unitPx(FontSizes.BODY), FontWeights.REGULAR, Colors.GREY, unitPx(Spacing.M_Y * 2), slideIn);
var Wrapper = styled.div.attrs({
  'data-id': function dataId(props) {
    return props['data-id'];
  }
}).withConfig({
  displayName: "Accordion__Wrapper",
  componentId: "sc-1xkc3dm-2"
})(["background-color:", ";border-bottom:solid 1px ", ";", ";", ";"], Colors.WHITE, Colors.GREY16, media.LG(_templateObject(), Header, Colors.GREY4), function (_ref3) {
  var borderTop = _ref3.borderTop;
  return borderTop && "border-top: solid 1px ".concat(Colors.GREY16);
});
var Button = styled.button.withConfig({
  displayName: "Accordion__Button",
  componentId: "sc-1xkc3dm-3"
})(["display:flex;margin:0;padding:0;background-color:transparent;border:solid 1px transparent;color:", ";&:focus{outline:none;border:dotted 1px ", ";}"], Colors.RED_PINK, Colors.GREY48);
var EnhancedHeader = enhanceWithTrackable(Header);

var Accordion =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Accordion, _React$Component);

  function Accordion(props) {
    var _this;

    _classCallCheck(this, Accordion);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Accordion).call(this, props));

    _this._toggleOpenClose = function (e) {
      _this.props.onToggle({
        isOpen: !_this.state.isOpen
      });

      _this.setState(function (_ref4) {
        var isOpen = _ref4.isOpen,
            trackedClose = _ref4.trackedClose,
            trackedOpen = _ref4.trackedOpen;
        var newState = {
          isOpen: !isOpen,
          trackedClose: trackedClose,
          trackedOpen: trackedOpen
        };

        if (isOpen) {
          newState.trackedClose = true;
        } else if (!isOpen) {
          newState.trackedOpen = true;
        }

        return newState;
      });
    };

    _this.state = {
      isOpen: props.open,
      trackedClose: false,
      // disables after one open and one close
      trackedOpen: false
    };
    return _this;
  }
  /**
   * Enables group of accordions to be toggle/untoggle by consumers
   * @param nextProps
   */


  _createClass(Accordion, [{
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.open !== this.state.isOpen) {
        this.setState({
          isOpen: nextProps.open
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          label = _this$props.label,
          smallLabel = _this$props.smallLabel,
          subTitle = _this$props.subTitle,
          borderTop = _this$props.borderTop,
          dataId = _this$props['data-id'],
          condensed = _this$props.condensed,
          trackingDisabled = _this$props.trackingDisabled;
      var _this$state = this.state,
          isOpen = _this$state.isOpen,
          trackedClose = _this$state.trackedClose,
          trackedOpen = _this$state.trackedOpen;
      var Icon = !isOpen ? AddIcon : RemoveIcon;
      var openClass = isOpen ? 'open' : 'closed';
      var accessibilityLabel = !isOpen ? 'Open' : 'Close';
      var postClickState = !isOpen ? 'opened' : 'closed';
      var wrappedDataId = dataId || Accordion.displayName;
      return React.createElement(Wrapper, {
        borderTop: borderTop,
        "data-id": "".concat(wrappedDataId, "-container")
      }, React.createElement(EnhancedHeader, {
        className: openClass,
        "data-id": wrappedDataId,
        onClick: this._toggleOpenClose,
        condensed: condensed,
        postClickState: postClickState,
        trackingDisabled: trackingDisabled || trackedClose && trackedOpen,
        label: label,
        smallLabel: smallLabel
      }, React.createElement(Box, {
        width: "100%"
      }, React.createElement(Heading4, {
        text: label
      }), subTitle ? React.createElement(Box, {
        marginTop: 1
      }, React.createElement(Text, {
        color: "grey80",
        size: "xs"
      }, subTitle)) : null), React.createElement(Button, {
        type: "button"
      }, React.createElement(Icon, {
        accessibilityLabel: accessibilityLabel,
        color: "redPink"
      }))), React.createElement(Body, {
        className: openClass
      }, children));
    }
  }]);

  return Accordion;
}(React.Component);

Accordion.propTypes = {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]).isRequired,
  label: PropTypes.string.isRequired,
  subTitle: PropTypes.string,
  open: PropTypes.bool,
  borderTop: PropTypes.bool,
  'data-id': PropTypes.string,
  condensed: PropTypes.bool,
  trackingDisabled: PropTypes.bool,
  onToggle: PropTypes.func
};
Accordion.displayName = DISPLAY_NAME;
Accordion.defaultProps = {
  open: false,
  borderTop: false,
  onToggle: function onToggle() {},
  condensed: false
};
export { Accordion };